import * as React from "react";
import { Col, Container, Row } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import { ViewAndDownload } from "../Modules/Helper";
import { Helmet } from "react-helmet";
import Footer from "../Modules/Footer";
import NavigationBar from "../Modules/NavigationBar";

export default function Legal() {
	return (
		<>
			<Helmet>
				<title>{"EarsOnly | Legal"}</title>
			</Helmet>
			<NavigationBar />
			<Container className="container-padding">
				<h1>Wet- en regelgeving</h1>
				<h3>Nederlands</h3>
				<hr />

				<ViewAndDownload
					title="Privacyverklaring"
					path="/documents/legal/Nederlands/EarsOnlyPrivacyverklaringNL.pdf"
				/>
				
				<ViewAndDownload
					title="EU-conformiteitsverklaring - D0002"
					path="/documents/legal/Nederlands/SPE-DP016-012_v1.0_DoC_EU_DECLARATION_OF_CONFORMITY-NL.pdf"
				/>
				<ViewAndDownload
					title="Algemene Voorwaarden (Weder verkoop)"
					path="/documents/legal/Nederlands/EarsOnly_ALGEMENE_VOORWAARDEN_Wederverkoop_NL.pdf"
				/>

				<br />
				<br />
				<br />
				<h3>English</h3>
				<hr />

				<ViewAndDownload
					title="Privacy Policy"
					path="/documents/legal/English/MyEarsOnlyPrivacyPolicy.pdf"
				/>
				<ViewAndDownload
					title="EU Declaration of Conformity - D0002"
					path="/documents/legal/English/SPE-DP016-012_v1.0_DoC_EU_DECLARATION_OF_CONFORMITY-EN.pdf"
				/>
				<ViewAndDownload
					title="Terms of service (Resale)"
					path="/documents/legal/English/EarsOnly_GENERAL_TERMS-Resale_EN.pdf"
				/>
				<hr />
				<br />
				<ViewAndDownload
					title="EU Declaration of Conformity - D0001"
					path="/documents/SPE-DP011-003_v2.0_DoC_EU_DECLARATION_OF_CONFORMITY.pdf"
				/>
			</Container>
			<Footer />
		</>
	);
}